/**
 * Returns "true" if app environment is 'development'.
 */
export function isDevEnvironment(): boolean {
    return process.env.NODE_ENV === 'development';
}

/**
 * Write message to console if app environment is 'development'.
 */
export function devLog(message, ...optionalParams): void {
    if (isDevEnvironment()) {
        console.log(message, ...optionalParams);
    }
}

/**
 * Write warning to console if app environment is 'development'.
 */
export function devWarning(message: string) {
    if (isDevEnvironment()) {
        console.warn(message);
    }
}

/**
 * Write error to console if app environment is 'development'.
 */
export function devError(error: string | Error) {
    if (isDevEnvironment()) {
        console.error(error);
    }
}

export function isFirefox(): boolean {
    return navigator.userAgent.includes('Firefox');
}
